export enum DownloadCsvDetails {
  ALL = 'ALL',
  PAYER = 'PAYER',
  EVERTRANSIT = 'EVERTRANSIT',
  KINETIK = 'KINETIK',
  MTM = 'MTM',
  // NY Medical Answering Services
  MAS = 'MAS',
  TENNESSEE_CARRIERS = 'TENNESSEE_CARRIERS',
}

export enum InvoicedTripsValue {
  ALL_TRIPS = 'all',
  INVOICED_TRIPS = 'invoiced',
  NOT_INVOICED_TRIPS = 'not_invoiced',
  PAID_INVOICE_TRIPS = 'paid_invoice',
  UNPAID_INVOICE_TRIPS = 'unpaid_invoice',
}

export const payersStorageKey = 'trip-payers-filter';
export const statusesStorageKey = 'trip-statuses-filter';
export const tagsStorageKey = 'trip-tags-filter';
export const dateRangeStorageKey = 'trips-daterange-filter';
export const createdAtDateRangeStorageKey = 'trips-created-at-daterange-filter';
export const driverStorageKey = 'trip-drivers-filter';
export const priceStorageKey = 'trip-price-filter';

export const OTHER_REASON_PREFIX = 'other|';
